module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 0
// module chunks = 1 3 4 5 6 7